export interface GlobalContent {
  contact: {
    email: string;
  };
  footer: {
    line1: string;
    line2: string;
  };
  seo: {
    title: string;
    description: string;
    url: string;
  };
}

export const content: GlobalContent = {
  contact: {
    email: "support@cloud-talent.com",
  },
  footer: {
    line1: "Cloud Talent Services® by Prosight LLC",
    line2: "Registered DBE/MBE based in Atlanta GA",
  },
  seo: {
    title: "Cloud Talent Services",
    description:
      "We are Cloud Talent Staffing specialists - Sourcing top candidates for your Cloud, Legacy and Hybrid environment covering AppDev, DevOps, CyberSec and Infrastructure (Network, Data Center, wireless).",
    url: "https://cloud-talent.com",
  },
};
